import { ListingStatusData } from '../../../components/Listing/types';
import { APIListingItemNotification } from '../types';
import { mapListingNotificationType } from './mapListingNotificationType';
import { APIListingNotificationLinkType } from '../types/APIListingNotification';
/**
 * Maps over an API Listing's notification and converts into @reference {InfoPanel}
 */
export function mapListingNotification<
  T extends APIListingNotificationLinkType
>({
  notificationType,
  title,
  link,
  message,
}: APIListingItemNotification<T>): ListingStatusData {
  switch (link?.linkType) {
    case 'ViewPaymentDetails':
      return {
        type: mapListingNotificationType(notificationType),
        title,
        message: message || undefined,
        linkLabel: link.label || undefined,
        linkActionType: 'view-payment-details',
        linkActionData: {
          ...link.data,
        },
      };
    default:
      return {
        type: mapListingNotificationType(notificationType),
        title,
        message: message || undefined,
        link: link?.data || undefined,
        linkLabel: link?.label || undefined,
      };
  }
}
